<template>
  <div>
    <div
      class="text-md font-medium text-white py-2 px-5 rounded mt-4 cursor-pointer flex justify-between"
      v-on:click="show_div = !show_div"
      :class="
        show_div
          ? 'bg-theme-1 text-white'
          : 'bg-white border border-theme-1 text-theme-1 hover:bg-theme-1 hover:text-white'
      "
    >
      <span class="my-auto"
        >{{ show_div ? 'Ocultar' : 'Ver' }} horas por cuenta</span
      >
      <span class="font-bold text-lg">{{ show_div ? '-' : '+' }}</span>
    </div>
    <div class="overflow-auto intro-y mt-4" v-if="show_div">
      <table class="w-full mb-4">
        <thead>
          <tr class="intro-x bg-white">
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
            >
              CUENTA
            </th>
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
              v-bind:class="item == today ? 'bg-theme-1 text-white' : ''"
              v-for="(item, key) in dates"
              v-bind:key="'headers' + key"
            >
              {{ item }}
            </th>
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
            >
              HORAS SEMAMA
            </th>
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
            >
              HORAS USADAS
            </th>
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
            >
              DIS
            </th>
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
            >
              %
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="intro-x bg-white"
            v-for="(hour, index) in hours"
            v-bind:key="'hours' + index"
          >
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ hour.account }}
              </div>
            </td>
            <td
              v-for="(item, key) in dates"
              v-bind:key="'accounts' + key"
              class="border border-gray-100"
            >
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ hour[item] }}
              </div>
            </td>
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ hour.hours }}
              </div>
            </td>
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ hour.hours_used }}
              </div>
            </td>
            <td class="border border-gray-100" :class="hour.percentage_color">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ (hour.hours - hour.hours_used).toFixed(2) }}
              </div>
            </td>
            <td class="border border-gray-100" :class="hour.percentage_color">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ hour.percentage }}%
              </div>
            </td>
          </tr>
          <tr class="intro-x bg-white/20">
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
              >
                TOTAL DIA
              </div>
            </td>
            <td
              v-for="(item, key) in dates"
              v-bind:key="'accounts' + key"
              class="border border-gray-100"
            >
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                <b>{{ hours_by_dates[item] }}</b> /
                {{ hours_by_today.toFixed(2) }}
              </div>
            </td>
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ sumHoursWeek }}
              </div>
            </td>
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
              >
                {{ sumHoursUsedWeek }}
              </div>
            </td>
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
              >
                {{ (sumHoursWeek - sumHoursUsedWeek).toFixed(0) }}
              </div>
            </td>
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
              >
                {{ ((sumHoursUsedWeek * 100) / sumHoursWeek).toFixed(0) }}%
              </div>
            </td>
          </tr>
          <tr class="intro-x bg-white/20">
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
              >
                DISPONIBLES
              </div>
            </td>
            <td
              v-for="(item, key) in dates"
              v-bind:key="'accounts' + key"
              class="border border-gray-100"
              :class="
                hours_by_today < hours_by_dates[item]
                  ? 'bg-red-200'
                  : hours_by_today == hours_by_dates[item]
                  ? 'bg-gray-200'
                  : 'bg-green-200'
              "
            >
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ (hours_by_today - hours_by_dates[item]).toFixed(2) }}
              </div>
            </td>
            <td
              class="border border-gray-100 font-bold"
              colspan="2"
              :class="
                sumHoursUsedWeek > sumHoursWeek
                  ? 'bg-red-300'
                  : sumHoursUsedWeek == sumHoursWeek
                  ? 'bg-gray-200'
                  : 'bg-green-300'
              "
            >
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ (sumHoursWeek - sumHoursUsedWeek).toFixed(2) }}
              </div>
            </td>
            <td class="border border-gray-100"></td>
            <td class="border border-gray-100"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dates', 'hours', 'hours_by_dates'],
  data() {
    return {
      today: new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'America/Bogota',
      }).format(new Date()),
      hours_by_today: 0,
      show_div: true,
    }
  },
  computed: {
    sumHoursWeek() {
      let sum = 0
      this.hours.filter((item) => {
        if (item.hours) {
          sum = sum + item.hours
        }
      })
      this.hours_by_today = sum / 5

      return sum
    },
    sumHoursUsedWeek() {
      let sum = 0
      this.hours.filter((item) => {
        if (item.hours_used) {
          sum = sum + item.hours_used
        }
      })
      return sum
    },
  },
}
</script>



// WEBPACK FOOTER //
// HoursPlanning.vue?2e145773